module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921051149_T.cb26ff7e.jpg";